import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TProductCode } from '@/shared/types/product-types'

export type AccessoriesOfferAction = 'cart' | 'fast' | 'preorder'

type AccessoriesOfferState = {
	action?: AccessoriesOfferAction
	isEnabled: boolean
	productCode?: TProductCode
	productId?: number
	orderQuery?: Record<string, string>
	productPreview?: { TITLE?: string; IMAGE?: string }
	selectedAccessoryIds: number[]
}

export type OpenAccessoriesOfferPayload = Pick<
	Required<AccessoriesOfferState>,
	'action' | 'productCode' | 'productId'
> &
	Pick<AccessoriesOfferState, 'orderQuery' | 'productPreview'>

const initialState: AccessoriesOfferState = {
	isEnabled: false,
	selectedAccessoryIds: []
}

const accessoriesOfferSlice = createSlice({
	name: 'accessoriesOffer',
	initialState,
	reducers: {
		enableAccessoriesOffer: state => {
			state.isEnabled = true
		},
		disableAccessoriesOffer: () => initialState,
		openAccessoriesOffer: (state, action: PayloadAction<OpenAccessoriesOfferPayload>) => {
			state.action = action.payload.action
			state.productCode = action.payload.productCode
			state.productId = action.payload.productId
			state.orderQuery = action.payload.orderQuery
			state.productPreview = action.payload.productPreview
			state.selectedAccessoryIds = []
		},
		closeAccessoriesOffer: state => {
			state.action = undefined
			state.productCode = undefined
			state.productId = undefined
			state.orderQuery = undefined
			state.productPreview = undefined
			state.selectedAccessoryIds = []
		},
		selectAccessoriesOfferProduct: (state, action: PayloadAction<number>) => {
			if (!state.selectedAccessoryIds.includes(action.payload)) state.selectedAccessoryIds.push(action.payload)
		}
	}
})

export const {
	closeAccessoriesOffer,
	disableAccessoriesOffer,
	enableAccessoriesOffer,
	openAccessoriesOffer,
	selectAccessoriesOfferProduct
} = accessoriesOfferSlice.actions
export const accessoriesOfferReducer = accessoriesOfferSlice.reducer
